export default "__VITE_ASSET__DC2xR0Oz__"